import { render, staticRenderFns } from "./CreatePhaseStatusVerticalStep2.vue?vue&type=template&id=1666d483&"
import script from "./CreatePhaseStatusVerticalStep2.vue?vue&type=script&lang=ts&"
export * from "./CreatePhaseStatusVerticalStep2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports